import { useQuery } from 'react-query';
import DmsService from 'Services/DMS/dms-api.service';

const normalizeUnitId = (value) => String(value || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
const normalizeName = (value) => String(value || '').trim().toLowerCase();

/** Match by uId (case/separator-insensitive); fall back to the unit name the fleet hub sends. */
const findJobUnit = (units, unitUId, unitName) => {
    const uid = normalizeUnitId(unitUId);
    const byUid = uid && units.find((u) => normalizeUnitId(u.uId) === uid);
    if (byUid) return byUid;
    const name = normalizeName(unitName);
    if (!name) return null;
    return units.find((u) => [u.name, u.nameEng, u.nameLocalized, u.nameUser]
        .some((candidate) => normalizeName(candidate) === name)) || null;
};

/**
 * Units with pressure channels of the license's blender (Job 0) and MPC (5) jobs, used by the fleet custom channel picker.
 * Units keep the order of jobIds, so the blender job's own unit is matched first. Cached per job set across tiles.
 */
const EMPTY_UNITS = [];

export default function useFleetJobChannels(jobIds, unitUId, enabled = true, unitName = null) {
    const ids = (Array.isArray(jobIds) ? jobIds : [jobIds]).filter((id) => id != null);
    const query = useQuery(
        ['fleet-pressure-channels', ...ids],
        () => DmsService.getFleetPressureChannels(ids),
        {
            enabled: ids.length > 0 && enabled,
            staleTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false,
        }
    );

    const units = query.data || EMPTY_UNITS;
    const unit = findJobUnit(units, unitUId, unitName);

    return {
        ...query,
        units,
        unit,
        channels: unit?.channels || [],
    };
}
